
import React from "react";
import { useState, useEffect } from 'react';
import Title from '../Title';
import CenteredTitle from "./CenteredTitle";


const MaintenanceMode = () => {

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  const styles = {
    wrapper: {
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
      background: "#ffffff",
      fontFamily: "JohnsonText-Regular, sans-serif",
    },
    container: {
      flex: 1,
      background: "#f8f8f6",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "0 20px",
    },
    card: {
      background: "#fff",
      borderRadius: "1rem",
      boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
      padding: "60px 40px",
      maxWidth: "500px",
      textAlign: "center",
      border: "2px solid #e5e5e5",
    },
    spinner: {
      margin: "0 auto 30px",
      border: "6px solid #e5e7eb",
      borderTop: "6px solid #d71920",
      borderRadius: "50%",
      width: "70px",
      height: "70px",
      animation: "spin 1s linear infinite",
    },
    '@keyframes spin': {
      to: { transform: "rotate(360deg)" }
    },
    text: {
      color: "#222",
      fontSize: "1.1rem",
      marginTop: "28px",
      display: 'flex',
      flexDirection: 'column',
      gap: isMobile ? '1rem' : '0.5rem',
    },
    footer: {
      color: "#888",
      textAlign: "center",
      fontSize: "0.95rem",
      padding: "20px 0",
      borderTop: "1px solid #e5e5e5",

      display: isMobile ? 'flex' : 'block',
      flexDirection: isMobile ? 'column' : 'row',
      alignItems: isMobile ? 'center' : 'start',
      justifyContent: isMobile ? 'center' : 'start'
    },
    downtimeImage: {
      maxWidth: '40%',
      height: 'auto',
      marginBottom: '30px',
      borderRadius: '8px' // Optional styling
    },
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  return (
    <div style={styles.wrapper}>

      <div style={{ display: 'flex', flexDirection: 'column', borderBottom: "1px solid #e5e5e5" }}>
        <div className="topbar" style={{ justifyContent: isMobile ? 'center' : 'start' }}>
          <img src="logos/JJ_Logo_SingleLine_Red_RGB.png" width={'257.91px'} height={'50px'} alt="JnJ Header Logo"/>
        </div>
      </div>

      <div style={styles.container}>
        <div style={styles.card}>
          <img 
              src="logos/DowntimeImg.png" 
              style={styles.downtimeImage}
            />
          
          
          <CenteredTitle title={'Website Under Maintenance'} />
          

          <div style={styles.text}>
            <span>Our website is currently undergoing scheduled maintenance.</span>
            <span>We will be back shortly.<br/>Thank you for your patience.</span>
          </div>
          
        </div>
      </div>

      <div style={styles.footer}>
        <span>All contents © Janssen Pharmaceutica NV. </span>
        <span>All rights reserved.</span>
      </div>

      <style>
        {`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}
      </style>

    </div>
  )

}

export default MaintenanceMode;
